import { NgModule } from '@angular/core';
import { PrizmCheckedDirective } from './checked.directive';

@NgModule({
  declarations: [PrizmCheckedDirective],
  exports: [PrizmCheckedDirective],
})
export class PrizmCheckedModule {}
